// LiipImagine filter set names. Each rendering slot picks a filter from its
// tenant backend. `resolveImageUrl` substitutes that name into the template.
export const ImageFilter = {
  product_card: 'product_card',
  product_card_recommendation: 'product_card_recommendation',
  product_card_search_suggest_top: 'product_card_search_suggest_top',
  product_card_search_suggest: 'product_card_search_suggest',
  product_association_color: 'product_association_color',
  product_association_color_mobile: 'product_association_color_mobile',
  product_set_item: 'product_set_item',
  product_card_cart: 'product_card_cart',
  product_gallery_preview_main: 'product_gallery_preview_main',
  product_gallery_preview_thumbnail: 'product_gallery_preview_thumbnail',
  product_gallery_modal_main: 'product_gallery_modal_main',
  product_gallery_modal_thumbnail: 'product_gallery_modal_thumbnail',
  product_brand_logo: 'product_brand_logo',
  product_comparison_table_header: 'product_comparison_table_header',
  product_comparison_sticky_header: 'product_comparison_sticky_header',
  brand_list: 'brand_list',
  product_ecomail: 'product_ecomail',
  taxon_megamenu: 'taxon_megamenu',
  taxon_hamburger: 'taxon_hamburger',
  blog_category: 'blog_category',
  blog_author_avatar: 'blog_author_avatar',
  blog_article_thumb_small: 'blog_article_thumb_small',
  blog_article_thumb: 'blog_article_thumb',
  blog_article_thumb_homepage: 'blog_article_thumb_homepage',
  blog_article_main: 'blog_article_main',
  blog_article_main_2x: 'blog_article_main_2x',
  cms_page_content_image: 'cms_page_content_image',
  cms_page_content_image_2x: 'cms_page_content_image_2x',
  cms_page_content_two_images: 'cms_page_content_two_images',
  cms_page_content_two_images_2x: 'cms_page_content_two_images_2x',
  cms_page_content_images_collection: 'cms_page_content_images_collection',
  cms_page_content_images_collection_2x: 'cms_page_content_images_collection_2x',
  cms_page_content_team_avatar: 'cms_page_content_team_avatar',
  cms_page_content_button_grid: 'cms_page_content_button_grid',
  /**
   * Article
   * */
  meta_image_media_manager: 'meta_image_media_manager',
  /*
   * Taxon, Product, Brand
   * */
  meta_image_sylius_image: 'meta_image_sylius_image',
  shipping_method: 'shipping_method',
  payment_method: 'payment_method',
  banner_homepage_desktop_image: 'banner_homepage_desktop_image',
  banner_mobil: 'banner_mobil',
  banner_tablet: 'banner_tablet',
  banner_desktop: 'banner_desktop',
  banner_listing: 'banner_listing',
  /**
   * The uploaded original, without resizing.
   * */
  sylius_original: 'sylius_original',
} as const;

export type ImageFilterT = (typeof ImageFilter)[keyof typeof ImageFilter];
